export { default } from './LyricSample';
